(function () {
  'use strict';

  if (window.__hadiyahTapResilienceBound) return;
  window.__hadiyahTapResilienceBound = true;

  const TAP_SLOP_PX = 12;
  const PRESS_FEEDBACK_TIMEOUT_MS = 1800;
  const CHECKOUT_TIMEOUT_MS = 12000;
  const ACTION_READY_TIMEOUT_MS = 16000;
  const ACTION_READY_POLL_MS = 80;
  const PRODUCT_ACTION_SELECTOR = [
    '.product-form__buttons [name="add"]',
    'sticky-atc [name="add"]',
    'sticky-atc .product-form__submit',
    'sticky-atc .add-to-cart-button',
    '[data-type="customeowApp"] button',
    '[data-type="customeowApp"] a',
    '[data-type="customeowApp"] [role="button"]',
    '[data-type="customeowApp"] input[type="button"]',
    '[data-type="customeowApp"] input[type="submit"]',
  ].join(', ');
  const GENERIC_ACTION_CONTROL_SELECTOR =
    'button, [role="button"], input[type="button"], input[type="submit"], a[href]';

  let deliveryGesture = null;
  let queuedProductAction = null;
  const pressFeedbackTimers = new WeakMap();
  const replayingControls = new WeakSet();

  function installStyles() {
    if (document.getElementById('hadiyah-tap-resilience-styles')) return;

    const style = document.createElement('style');
    style.id = 'hadiyah-tap-resilience-styles';
    style.textContent = `
      [data-hadiyah-delivery-method-card],
      .product-form__buttons [name="add"],
      sticky-atc [name="add"],
      sticky-atc .product-form__submit,
      sticky-atc .add-to-cart-button,
      [data-clean-shopify-checkout],
      [data-clean-gokwik-checkout] {
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;
      }

      [data-hadiyah-delivery-method-card] {
        -webkit-user-select: none;
        user-select: none;
      }

      [data-hadiyah-delivery-method-card].hadiyah-tap-pending,
      .product-form__buttons [name="add"].hadiyah-tap-pending,
      sticky-atc [name="add"].hadiyah-tap-pending,
      sticky-atc .product-form__submit.hadiyah-tap-pending,
      sticky-atc .add-to-cart-button.hadiyah-tap-pending,
      [data-clean-shopify-checkout].hadiyah-tap-pending {
        filter: brightness(0.96);
        transform: translate3d(0, 0, 0) scale(0.99);
      }

      [data-clean-shopify-checkout].hadiyah-checkout-busy {
        position: relative;
        pointer-events: none;
        cursor: wait;
        opacity: 0.82;
      }

      [data-clean-shopify-checkout].hadiyah-checkout-busy::after {
        width: 1.4rem;
        height: 1.4rem;
        flex: 0 0 1.4rem;
        border: 2px solid rgb(255 255 255 / 42%);
        border-top-color: #fff;
        border-radius: 50%;
        content: '';
        animation: hadiyah-checkout-spin 700ms linear infinite;
      }

      .hadiyah-action-busy {
        position: relative !important;
        pointer-events: none !important;
        cursor: wait !important;
        opacity: 0.82 !important;
      }

      .hadiyah-action-busy::after {
        position: absolute !important;
        top: 50% !important;
        right: 1.4rem !important;
        left: auto !important;
        width: 1.4rem !important;
        height: 1.4rem !important;
        border: 2px solid rgb(255 255 255 / 45%) !important;
        border-top-color: currentcolor !important;
        border-radius: 50% !important;
        background: transparent !important;
        content: '' !important;
        transform: translateY(-50%);
        animation: hadiyah-action-spin 700ms linear infinite !important;
      }

      @keyframes hadiyah-checkout-spin {
        to { transform: rotate(360deg); }
      }

      @keyframes hadiyah-action-spin {
        to { transform: translateY(-50%) rotate(360deg); }
      }

      @media (prefers-reduced-motion: reduce) {
        [data-hadiyah-delivery-method-card].hadiyah-tap-pending,
        .product-form__buttons [name="add"].hadiyah-tap-pending,
        sticky-atc [name="add"].hadiyah-tap-pending,
        sticky-atc .product-form__submit.hadiyah-tap-pending,
        sticky-atc .add-to-cart-button.hadiyah-tap-pending,
        [data-clean-shopify-checkout].hadiyah-tap-pending {
          transform: none;
        }

        [data-clean-shopify-checkout].hadiyah-checkout-busy::after {
          animation-duration: 1400ms;
        }

        .hadiyah-action-busy::after {
          animation-duration: 1400ms !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function isPrimaryPointer(event) {
    return event.isPrimary !== false && (event.pointerType === 'touch' || event.pointerType === 'pen');
  }

  function isUnavailableControl(control) {
    return Boolean(
      !control ||
      control.disabled ||
      control.hidden ||
      control.getAttribute('aria-disabled') === 'true' ||
      control.getAttribute('aria-hidden') === 'true'
    );
  }

  function setPressFeedback(control, active) {
    if (!control) return;

    const previousTimer = pressFeedbackTimers.get(control);
    if (previousTimer) window.clearTimeout(previousTimer);
    pressFeedbackTimers.delete(control);
    control.classList.toggle('hadiyah-tap-pending', active);

    if (!active) return;
    const timer = window.setTimeout(function () {
      control.classList.remove('hadiyah-tap-pending');
      pressFeedbackTimers.delete(control);
    }, PRESS_FEEDBACK_TIMEOUT_MS);
    pressFeedbackTimers.set(control, timer);
  }

  function clearDeliveryGesture() {
    if (deliveryGesture?.card) setPressFeedback(deliveryGesture.card, false);
    deliveryGesture = null;
  }

  function beginDeliveryGesture(event, card) {
    if (!isPrimaryPointer(event)) return;

    const input = card.querySelector('[data-hadiyah-delivery-method-input]');
    if (isUnavailableControl(input)) return;

    clearDeliveryGesture();
    deliveryGesture = {
      pointerId: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      moved: false,
      card,
      input,
    };
    setPressFeedback(card, true);
  }

  function updateDeliveryGesture(event) {
    if (!deliveryGesture || event.pointerId !== deliveryGesture.pointerId) return;
    if (
      Math.abs(event.clientX - deliveryGesture.startX) > TAP_SLOP_PX ||
      Math.abs(event.clientY - deliveryGesture.startY) > TAP_SLOP_PX
    ) {
      deliveryGesture.moved = true;
      setPressFeedback(deliveryGesture.card, false);
    }
  }

  function completeDeliveryGesture(event) {
    const gesture = deliveryGesture;
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    deliveryGesture = null;
    setPressFeedback(gesture.card, false);

    if (gesture.moved || isUnavailableControl(gesture.input)) return;

    const picker = gesture.card.closest('hadiyah-delivery-picker');
    if (!picker) return;

    // Commit at pointerup, before WebKit's later compatibility click. This is
    // idempotent: the native radio click may still follow, but cannot toggle a
    // radio off or create a second cart/product action.
    const changed = !gesture.input.checked;
    gesture.input.checked = true;

    if (typeof picker.selectDeliveryMethod === 'function') {
      picker.selectDeliveryMethod(gesture.input.value, true);
    } else if (changed) {
      gesture.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function beginProductActionFeedback(event, control) {
    if (!isPrimaryPointer(event) || isUnavailableControl(control)) return;
    setPressFeedback(control, true);
  }

  function clearProductActionFeedback(event) {
    const control = findProductActionControl(event.target);
    if (!control) return;

    // Leave the pressed state visible until the browser delivers click. Existing
    // product-form/Customeow loading states then take over without us submitting
    // or synthesizing another click.
    window.setTimeout(function () {
      setPressFeedback(control, false);
    }, 0);
  }

  function getProductActionLabel(control) {
    return (
      control?.querySelector?.('.add-to-cart-text__content, .add-to-cart-text')?.textContent ||
      control?.textContent ||
      control?.value ||
      control?.getAttribute?.('aria-label') ||
      ''
    )
      .trim()
      .toLowerCase();
  }

  function labelIsCartAction(label) {
    return Boolean(
      label &&
      (label.includes('add to cart') ||
        label.includes('add to bag') ||
        label.includes('confirm & add') ||
        label.includes('confirm and add') ||
        label === 'finish' ||
        label === 'done')
    );
  }

  function getCustomeowSurfaceForControl(control) {
    if (!control) return null;

    const activeSurface = window.PdpNameVariantSync?.getActiveCustomeowSurface?.();
    if (activeSurface?.contains?.(control)) return activeSurface;

    const identityRoot = control.closest(
      '[data-type="customeowApp"], [class*="customeow" i], [id*="customeow" i], [class*="staticmeow" i], [id*="staticmeow" i]'
    );
    if (identityRoot) return identityRoot;

    const modal = control.closest('[role="dialog"], [aria-modal="true"]');
    if (
      !modal ||
      modal.closest('[data-cart-addon-drawer], [data-clean-cart-drawer], cart-drawer')
    ) {
      return null;
    }

    const modalText = (modal.textContent || '').toLowerCase();
    const hasCustomizationContent =
      modal.querySelector('[name^="properties["], canvas, [contenteditable="true"]') ||
      modalText.includes('personalization') ||
      modalText.includes('personalisation') ||
      modalText.includes('customization') ||
      modalText.includes('customisation');
    return hasCustomizationContent ? modal : null;
  }

  function findProductActionControl(target) {
    const directControl = target?.closest?.(PRODUCT_ACTION_SELECTOR);
    if (directControl) return directControl;

    const control = target?.closest?.(GENERIC_ACTION_CONTROL_SELECTOR);
    if (!control || !labelIsCartAction(getProductActionLabel(control))) return null;
    return getCustomeowSurfaceForControl(control) ? control : null;
  }

  function getProductInfoForControl(control) {
    const directProductInfo = control?.closest?.('product-info');
    if (directProductInfo) return directProductInfo;

    const sticky = control?.closest?.('sticky-atc');
    const sectionId = sticky?.getAttribute?.('data-sticky-section-id');
    if (sectionId && window.CSS?.escape) {
      const escapedSectionId = window.CSS.escape(sectionId);
      const matchedProductInfo = document.querySelector(
        `product-info[data-section="${escapedSectionId}"], product-info[data-original-section="${escapedSectionId}"]`
      );
      if (matchedProductInfo) return matchedProductInfo;
    }

    return sticky ? document.querySelector('product-info') : null;
  }

  function getProductActionKind(control) {
    const label = getProductActionLabel(control);
    if (!label) return '';

    if (label.includes('customiz') || label.includes('customis')) return 'customize';

    const isCartAction = labelIsCartAction(label);

    if (getCustomeowSurfaceForControl(control)) return isCartAction ? 'customeow-add' : '';
    return control.closest('product-form-component, sticky-atc') ? 'product-add' : '';
  }

  function isProductActionReady(action, control = action?.control) {
    if (!action || !control) return false;

    const deliveryPicker = action.productInfo?.querySelector?.('hadiyah-delivery-picker');
    if (deliveryPicker && !deliveryPicker.hasAttribute('data-hadiyah-delivery-ready')) return false;

    if (action.kind === 'customeow-add') {
      return Boolean(
        window.__hadiyahCustomeowReliabilityBound &&
        window.PdpNameVariantSync?.getActiveCustomeowSurface
      );
    }

    if (action.kind === 'customize') {
      const scope = action.productInfo || document;
      return Boolean(
        window.PdpPersonalizeDrawer?.isAvailable?.(scope) ||
        window.PdpNameVariantSync?.openCustomeowEditor
      );
    }

    const sticky = control.closest('sticky-atc');
    if (sticky && (!customElements.get('sticky-atc') || !sticky.form)) return false;

    const component =
      control.closest('product-form-component') ||
      action.productInfo?.querySelector?.('product-form-component');
    return Boolean(
      component?.form &&
      typeof component.onSubmitHandler === 'function' &&
      typeof window.fetchConfig === 'function'
    );
  }

  function setProductActionBusy(control, busy) {
    if (!control) return;
    control.classList.toggle('hadiyah-action-busy', busy);
    control.classList.remove('hadiyah-tap-pending');
    if (busy) {
      control.setAttribute('aria-busy', 'true');
      control.dataset.hadiyahActionBusy = 'true';
    } else {
      control.removeAttribute('aria-busy');
      delete control.dataset.hadiyahActionBusy;
    }
  }

  function findCurrentActionControl(action) {
    if (action?.control?.isConnected) return action.control;

    const scope =
      action?.productInfo ||
      window.PdpNameVariantSync?.getActiveCustomeowSurface?.() ||
      document;
    return [...scope.querySelectorAll(PRODUCT_ACTION_SELECTOR)].find(function (candidate) {
      return getProductActionKind(candidate) === action.kind && !isUnavailableControl(candidate);
    });
  }

  function clearQueuedProductAction() {
    const action = queuedProductAction;
    if (!action) return null;
    window.clearInterval(action.pollTimer);
    window.clearTimeout(action.timeoutTimer);
    setProductActionBusy(action.control, false);
    queuedProductAction = null;
    return action;
  }

  function replayQueuedProductAction() {
    const action = clearQueuedProductAction();
    if (!action) return;

    const control = findCurrentActionControl(action);
    if (!control || isUnavailableControl(control)) return;

    if (action.kind === 'customize') {
      const scope = action.productInfo || document;
      if (window.PdpPersonalizeDrawer?.isAvailable?.(scope)) {
        window.PdpPersonalizeDrawer.open(scope);
        return;
      }
      if (window.PdpNameVariantSync?.openCustomeowEditor) {
        window.PdpNameVariantSync.openCustomeowEditor(scope, { target: control });
        return;
      }
    }

    replayingControls.add(control);
    control.click();
    window.setTimeout(function () {
      replayingControls.delete(control);
    }, 0);
  }

  function checkQueuedProductAction() {
    const action = queuedProductAction;
    if (!action) return;
    const control = findCurrentActionControl(action);
    if (control && isProductActionReady(action, control)) replayQueuedProductAction();
  }

  function queueProductAction(event, control) {
    if (!control || replayingControls.has(control)) {
      replayingControls.delete(control);
      return false;
    }

    const kind = getProductActionKind(control);
    if (!kind) return false;

    const action = {
      control,
      kind,
      productInfo: getProductInfoForControl(control),
      pollTimer: null,
      timeoutTimer: null,
    };
    if (isProductActionReady(action)) return false;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (queuedProductAction) return true;
    queuedProductAction = action;
    setProductActionBusy(control, true);
    window.__loadThemeCoreScripts?.();

    action.pollTimer = window.setInterval(checkQueuedProductAction, ACTION_READY_POLL_MS);
    action.timeoutTimer = window.setTimeout(function () {
      if (queuedProductAction !== action) return;
      clearQueuedProductAction();
      control.dispatchEvent(
        new CustomEvent('hadiyah:action:timeout', {
          bubbles: true,
          detail: { kind },
        })
      );
    }, ACTION_READY_TIMEOUT_MS);
    checkQueuedProductAction();
    return true;
  }

  function setDrawerStatus(drawer, message) {
    const status = drawer?.querySelector?.('[data-clean-cart-drawer-status]');
    if (!status) return;
    status.textContent = message || '';
    status.hidden = !message;
  }

  function getCheckoutLabel(link) {
    return link.querySelector('span') || link;
  }

  function setCheckoutBusy(link, busy) {
    if (!link) return;
    const label = getCheckoutLabel(link);

    if (busy) {
      if (link.dataset.hadiyahCheckoutBusy === 'true') return;
      link.dataset.hadiyahCheckoutBusy = 'true';
      link.dataset.hadiyahCheckoutPreviousAriaDisabled = link.getAttribute('aria-disabled') || '';
      link.dataset.hadiyahCheckoutLabel = label.textContent || 'CHECKOUT';
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('aria-busy', 'true');
      link.classList.remove('hadiyah-tap-pending');
      link.classList.add('hadiyah-checkout-busy');
      label.textContent = 'PREPARING CHECKOUT…';
      return;
    }

    if (link.dataset.hadiyahCheckoutBusy !== 'true') return;
    label.textContent = link.dataset.hadiyahCheckoutLabel || 'CHECKOUT';
    link.classList.remove('hadiyah-checkout-busy', 'hadiyah-tap-pending');
    link.removeAttribute('aria-busy');

    if (link.dataset.hadiyahCheckoutPreviousAriaDisabled) {
      link.setAttribute('aria-disabled', link.dataset.hadiyahCheckoutPreviousAriaDisabled);
    } else {
      link.removeAttribute('aria-disabled');
    }

    delete link.dataset.hadiyahCheckoutBusy;
    delete link.dataset.hadiyahCheckoutPreviousAriaDisabled;
    delete link.dataset.hadiyahCheckoutLabel;
  }

  function withTimeout(promise, timeoutMs) {
    let timer = null;
    const timeout = new Promise(function (_, reject) {
      timer = window.setTimeout(function () {
        reject(new Error('Checkout preparation took too long. Please try again.'));
      }, timeoutMs);
    });

    return Promise.race([Promise.resolve(promise), timeout]).finally(function () {
      if (timer) window.clearTimeout(timer);
    });
  }

  function waitForValue(getValue, timeoutMs) {
    const immediate = getValue();
    if (immediate) return Promise.resolve(immediate);

    return new Promise(function (resolve, reject) {
      const startedAt = Date.now();
      const timer = window.setInterval(function () {
        const value = getValue();
        if (value) {
          window.clearInterval(timer);
          resolve(value);
          return;
        }
        if (Date.now() - startedAt >= timeoutMs) {
          window.clearInterval(timer);
          reject(new Error('Checkout is taking longer than usual to load. Please try again.'));
        }
      }, ACTION_READY_POLL_MS);
    });
  }

  async function prepareAndOpenCheckout(link) {
    if (!link || link.dataset.hadiyahCheckoutBusy === 'true') return;

    const drawer = link.closest('[data-clean-cart-drawer]');
    const checkoutUrl = link.href || drawer?.dataset?.cleanCartCheckoutUrl || '/checkout';
    setCheckoutBusy(link, true);
    setDrawerStatus(drawer, '');

    try {
      if (typeof window.CleanCart?.fetch === 'function') {
        await withTimeout(window.CleanCart.fetch(), CHECKOUT_TIMEOUT_MS);
      }
      const checkoutRouter = window.CleanGokwik;
      if (typeof checkoutRouter?.routeCheckout === 'function') {
        const scope = link.closest('[data-clean-gokwik-scope]');
        const route = await withTimeout(
          checkoutRouter.routeCheckout(link, scope, {
            checkoutUrl,
            source: 'tap_resilience_shopify_control',
          }),
          CHECKOUT_TIMEOUT_MS,
        );
        if (route === 'gokwik') setCheckoutBusy(link, false);
        return;
      }
      const localization = await waitForValue(
        function () {
          return typeof window.HadiyahLocalization?.prepareCheckout === 'function'
            ? window.HadiyahLocalization
            : null;
        },
        CHECKOUT_TIMEOUT_MS
      );
      const localizationReady = await withTimeout(
        localization.prepareCheckout(checkoutUrl),
        CHECKOUT_TIMEOUT_MS,
      );
      if (localizationReady === false) return;
      window.location.assign(checkoutUrl);
    } catch (error) {
      setCheckoutBusy(link, false);
      setDrawerStatus(
        drawer,
        error?.message || 'Unable to prepare checkout. Please check your connection and try again.'
      );
    }
  }

  function onPointerDown(event) {
    const deliveryCard = event.target?.closest?.('[data-hadiyah-delivery-method-card]');
    if (deliveryCard) {
      beginDeliveryGesture(event, deliveryCard);
      return;
    }

    const checkout = event.target?.closest?.('[data-clean-shopify-checkout]');
    if (checkout) {
      if (isPrimaryPointer(event) && checkout.getAttribute('aria-disabled') !== 'true') {
        setPressFeedback(checkout, true);
      }
      return;
    }

    const productAction = findProductActionControl(event.target);
    if (productAction) beginProductActionFeedback(event, productAction);
  }

  function onPointerMove(event) {
    updateDeliveryGesture(event);
  }

  function onPointerCancel(event) {
    if (deliveryGesture && event.pointerId === deliveryGesture.pointerId) clearDeliveryGesture();

    const control =
      findProductActionControl(event.target) ||
      event.target?.closest?.('[data-clean-shopify-checkout]');
    if (control) setPressFeedback(control, false);
  }

  function onPointerUp(event) {
    completeDeliveryGesture(event);
  }

  function onClickCapture(event) {
    const checkout = event.target?.closest?.('[data-clean-shopify-checkout]');
    if (checkout) {
      if (
        event.button > 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (
        checkout.dataset.hadiyahCheckoutBusy === 'true' ||
        checkout.getAttribute('aria-disabled') === 'true'
      ) {
        return;
      }

      prepareAndOpenCheckout(checkout);
      return;
    }

    const productAction = findProductActionControl(event.target);
    if (productAction && queueProductAction(event, productAction)) return;

    clearProductActionFeedback(event);
  }

  installStyles();
  document.addEventListener('pointerdown', onPointerDown, true);
  document.addEventListener('pointermove', onPointerMove, true);
  document.addEventListener('pointercancel', onPointerCancel, true);
  document.addEventListener('pointerup', onPointerUp, true);
  document.addEventListener('click', onClickCapture, true);

  const earlyControl = window.__hadiyahEarlyActionBootstrap?.release?.();
  document.getElementById('hadiyah-early-action-styles')?.remove();
  if (earlyControl?.isConnected) {
    window.setTimeout(function () {
      earlyControl.click();
    }, 0);
  }

  window.addEventListener('pagehide', function () {
    clearDeliveryGesture();
    clearQueuedProductAction();
  });
})();
